export const STATISTIC_NAME = 'merchant_web'

/**
 * 装修统计
 */
// 点击装修预览
export const STATISTIC_DECORATION_PREVIEW = 'decoration_preview'
// 点击装修案例
export const STATISTIC_DECORATION_EXAMPLE = 'decoration_example'
// 点击装修编辑
export const STATISTIC_DECORATION_EDIT = 'decoration_edit'
// 点击首页装修 banner
export const STATISTIC_DECORATION_BANNER = 'decoration_banner'
// 点击复制店铺链接
export const STATISTIC_DECORATION_COPY = 'decoration_copy'
// 点击分享按钮（微博，qq空间）
export const STATISTIC_DECORATION_SHARE = 'decoration_share'
// 点击了解小程序
export const STATISTIC_DECORATION_TO_LITE_APP = 'decoration_to_lite_app'

/**
 * 智优投统计
 */
// 智优投点击充值
export const STATISTIC_PROMOTION_TO_RECHARGE = 'promotion_to_recharge'
// 智优投点击确认充值按钮
export const STATISTIC_PROMOTION_ENSURE_RECHARGE = 'promotion_ensure_recharge'
// 智优投完成充值
export const STATISTIC_PROMOTION_PAID = 'promotion_paid'
// 智优投点击新建计划按钮
export const STATISTIC_PROMOTION_NEW = 'promotion_new'
// 智优投点击提交计划按钮
export const STATISTIC_PROMOTION_NEW_SAVE = 'promotion_new_save'
// 智优投点击提交计划按钮（修改）
export const STATISTIC_PROMOTION_MODIFY_SAVE = 'promotion_modify_save'
// 智优投点击修改计划按钮
export const STATISTIC_PROMOTION_TO_MODIFY = 'promotion_to_modify'
// 智优投点击暂停计划按钮
export const STATISTIC_PROMOTION_STOP = 'promotion_stop'
// 智优投点击开启计划按钮
export const STATISTIC_PROMOTION_OPEN = 'promotion_open'
// 智优投点击提升预算
export const STATISTIC_PROMOTION_INCREASE_BUDGET = 'promotion_increase_budget'
// 智优投修改竞价埋点
export const STATISTIC_PROMOTION_MODIFY_PRICE = 'promotion_modify_price'

/**
 * poster统计
 */
// 首页banner跳转统计
export const STATISTIC_HOME_TOP_BANNER = 'home_top_banner'
/**
 * 首页统计
 */
// 首页常用功能
// 发布套餐
export const PUBLISH_SET_MEAL_HOME = 'publish_set_meal_home'
// 发布案例
export const PUBLISH_EXAMPLE_HOME = 'publish_example_home'
// 发布动态
export const PUBLISH_DYNAMIC_HOME = 'publish_dynamic_home'
// 推荐橱窗
export const RECOMMENDED_WINDOW_HOME_ONE = 'recommended_window_home_one'
// 店铺预览
export const SHOP_PREVIEW_HOME = 'shop_preview_home'
// 店铺装修
export const STATISTIC_COMMON_USE_DECORATION = 'common_use_decoration'
// 优惠券
export const STATISTIC_COMMON_USE_COUPON = 'common_use_coupon'
// 上传单品
export const STATISTIC_COMMON_USE_UPLOAD_GOOD = 'common_use_upload_good'
// 商品管理（加盟店）
export const STATISTIC_COMMON_USE_GOODS = 'common_use_goods'
// 收入管理
export const STATISTIC_COMMON_USE_INCOME_MANAGE = 'common_use_income_manage'
// 素材管理
export const STATISTIC_COMMON_USE_MATERIAL = 'common_use_material'
// 账户管理
export const STATISTIC_COMMON_SERIVE_ACCOUNT = 'common_service_account'

// 营销认证
//商家旗舰版
export const MERCHANT_PRO_HOME = 'merchant_pro_home'
//小程序
export const LITE_APP_HOME = 'lite_app_home'
//优惠券
export const COUPON_HOME = 'coupon_home'
//店铺橱窗
export const RECOMMENDED_WINDOW_HOME_TWO = 'recommended_window_home_two'

//开通旗舰版
export const OPEN_PRO_HOME = 'open_pro_home'

/**
 * 套餐管理统计
 */
//套餐优化
export const OPTIMIZATION_SET_MEAL = 'optimization_set_meal'
//推荐橱窗
export const RECOMMENDED_WINDOW_SET_MEAL = 'recommended_window_set_meal'
//发布套餐
export const PUBLISH_SET_MEAL_INNER = 'publish_set_meal_inner'
//套餐排序
export const SORT_SET_MEAL = 'sort_set_meal'

/**
 * 案例管理统计
 */
//案例优化
export const OPTIMIZATION_EXAMPLE = 'optimization_example'
//发布案例
export const PUBLISH_EXAMPLE_INNER = 'publish_example_inner'
//案例排序
export const SORT_EXAMPLE = 'sort_example'
//关联客照页面
export const CASE_INTRODUCE = 'case_introduce'

// web 首页商学院资讯
export const STATISTIC_COMMERCIAL_SCHOOL = 'home_commercial_school'

/**
 * 营销中心相关
 * 营销中心首页
 * 营销中心各服务
 */
export const STATISTIC_MARKETING_CENTER = 'marketing_center'
export const STATISTIC_MARKETING_ZHI_TUI_BAO = 'zhi_tui_bao_market'
export const STATISTIC_MARKETING_ZHI_GUANG_TONG = 'zhi_guang_tong_market'
export const STATISTIC_MARKETING_LIVE = 'live_market'
export const STATISTIC_MARKETING_JUKE = 'juke_market'

// 任务中心去完成
export const STATISTIC_TASK_CENTER_TASK = 'task_center_todo'
// 商家端首页任务中心入口
export const STATISTIC_TASK_CENTER_BANNER = 'task_center_banner'
